module.exports = __webpack_public_path__ + "static/img/shdfyy.731272b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/shdfyy.png
// module id = 57U6
// module chunks = 0